//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import GraphcardCommon from 'app_components/commons/graphcard'
import CoursesTaughtSkeleton from './coursesTaughtSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../coursesTaughtModule.scss'

// @ADD Component types
interface ICoursesTaughtModuleLayoutProps {
  currentYear: number,
  reportData: any
  chartOptions: any
  status: 'loading' | 'error' | null
}

const CoursesTaughtModuleLayout: React.FC<ICoursesTaughtModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='courses_taught_module-component'>
      <div className="title-graph">
        {`${t(`modules.courses_taught_module.title`)} ${props.currentYear}`}
      </div>
      <div className="graph">
        {props.status === 'loading' ? (
          <CoursesTaughtSkeleton />
        ) : (
          <>
            {props.reportData ? (
              <GraphcardCommon
                type='bars'
                data={props.reportData}
                options={props.chartOptions}
              />
            ): (
              <AlertComponent
                type='warning'
                title={t('modules.courses_taught_module.no_data')}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default CoursesTaughtModuleLayout
